export default "__VITE_ASSET__e772e3fc__"